<template>
  <v-app id="login" class="primary">
    <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4 lg4>
            <v-card class="elevation-1 pa-3">
              <v-form @submit.prevent="login">
              <v-card-text>
                <div class="layout column align-center">
                  <img src="/static/m.png" alt="Mosala Platform Admin" width="120" height="120">
                  <h1 class="flex my-4 primary--text">Mosala Dashboard</h1>
                </div>                
                
                  <v-text-field v-if="!isEmailOrName" v-show="!isEmailOrName" 
                  append-icon="person"
                  name="prénom" 
                  label="Prénom"
                  type="text" 
                  :error-messages="errors.collect('prénom')"
                  v-validate="'required'"
                  v-model="model.firstName">
                  </v-text-field>

                   <v-text-field
                   v-if="!isEmailOrName"
                   v-show="!isEmailOrName"
                   append-icon="person"
                   name="nom de famille"
                   label="Nom de famille"
                   type="text" 
                   :error-messages="errors.collect('nom de famille')"
                   v-validate="'required'"
                    v-model="model.lastName">
                   </v-text-field>

                    <v-text-field
                    v-if="isEmailOrName"
                    v-show="isEmailOrName"
                    append-icon="mail"
                    name="courriel"
                    label="email"
                    type="text"
                    v-model="model.email"
                    :error-messages="errors.collect('courriel')"
                    v-validate="'required|email'">
                    </v-text-field>

                  <v-text-field
                  append-icon="lock"
                  name="mot de passe"
                  label="Password"
                  type="password"
                  :error-messages="errors.collect('mot de passe')"
                   v-validate="'required'"
                  v-model="model.password">
                  </v-text-field>
                
              </v-card-text>
              <v-card-actions>
                <v-btn icon @click="isEmailOrName = ! isEmailOrName">
                  <v-icon large color="blue">{{this.adminIcon}}</v-icon>
                </v-btn>
                <h4 v-show="!isEmailOrName" class="flex my-4 primary--text">Utilisez votre email</h4>
                <h4 v-show="isEmailOrName" class="flex my-4 primary--text">Utilisez votre Nom et prénom</h4>
                
                <!-- <v-btn icon>
                  <v-icon color="light-blue">fa fa-twitter fa-lg</v-icon>
                </v-btn> -->
                <v-spacer></v-spacer>
                <v-btn type="submit" block color="primary" :loading="loading">Login</v-btn>
              </v-card-actions>
              </v-form>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
/* eslint-disable */
import { db } from "@/api/firebaseInit";
import firebase from "firebase";
import VeeValidate, { Validator } from "vee-validate";
import fr from "vee-validate/dist/locale/fr";
Validator.localize("fr", fr);
export default {
  name: "login",
   $_veeValidate: {
    validator: "new"
  },
  data: () => ({
    // loading: false,
    isEmailOrName: false,
    model: {
      firstName: "",
      lastName: "",
      email: "",
      password: ""
    }
  }),
  computed: {
     newEmail() {
      let email = this.model.firstName + this.model.lastName + "@mosala.work";
      email = email.replace(/\s+/g, "");
      return email;
    },
     signinUser () {
        return this.$store.getters.signinUser
    },
    loading: function() {
      return this.$store.getters.loginLoading;
    },
    adminIcon: function() {
      let adminIcon = String;
      adminIcon = this.isEmailOrName ? "account_circle" : "supervised_user_circle";
      return adminIcon;
    }
  },
    watch: {
      signinUser (value) {
  
        if (value !== null && value !== undefined) {
              
          if(value.type === 'A') {
            this.$store.commit('loginLoading', true);
          if(value.congregation =="ecc") {
                 this.$store.dispatch('fetchUsers_ecc') 
              this.$store.dispatch('fetchUsers')
           } else {
        // this.$store.dispatch('fetchEmployees')
       //  this.$store.dispatch('fetchConvos')
        //  this.$store.dispatch('fetchMessages')
         // this.$store.dispatch('fetchFriends')
          // this.$store.dispatch('fetchkyc')
          //this.$store.dispatch('fetchJobs')
           //this.$store.dispatch('fetchProjects')
                this.$store.dispatch('fetchUsers_ecc') 
              this.$store.dispatch('fetchUsers')
            }
           // this.$store.dispatch('fetchMembers')
            this.$router.push('/dashboard')
          }
          else if(value.type == 'S') {
             this.$store.commit('loginLoading', true);
        //  this.$store.dispatch('fetchMembers')
          this.$router.push('/dashboard')
         // this.$router.push('/widgets/serviteurs')
          }
        }
      }
    },
  methods: {
    login() {
      
     // this.$store.commit('loginLoading', true);
    //  this.$validator.validateAll().then(result => {
      //  console.log("result "+result)
        //if (result) {
          if (!this.isEmailOrName) {
        this.model.email = this.newEmail
      }
      console.log(this.model.email)
      this.$store.dispatch('signUserIn', {email: this.model.email, password: this.model.password})
       /* } else {
          this.$store.commit('loginLoading', false);
          return;
        }*/
      //});
    },

     showRegister: function() {
              this.$router.push("/register");
    },
    logout: function() {
      firebase
        .auth()
        .signOut()
        .then(() => {
          return;
        });
    }

    // login () {
    //   this.loading = true;
    //   setTimeout(() => {
    //     this.$router.push('/dashboard');
    //   }, 1000);
    // }
  }
};
</script>
<style scoped lang="css">
#login {
  height: 50%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  z-index: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue